<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">پرداخت با دیجی پی</h5>
        <div style="flex: 1"></div>
        <router-link
          :to="`/admin/shop/orders/${orderId}?print=1`"
          class="btn btn-secondary mx-3"
        >
        <span style="color:white !important;">
          پرینت فاکتور
        </span>
        </router-link>
        <Back url="/admin/shop" />
       
      </div>
      <div class="card-body">
        <form @submit.prevent="requestProduct">

          <b-form-group label="کد انبار">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input v-model="storeId" readonly/>
            </div>
          </b-form-group>
          <b-form-group label="مبلغ ارسال به دیجی پی(تومان)">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input :value="digipayCashierAmount | priceinput" readonly/>
            </div>
          </b-form-group>
          <b-form-group label="اسکن بارکد">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input autocomplete="off" autofocus ref="productSku" v-model="digipyBarcode"
                :disabled="disabledBarcode" @keypress.prevent.enter="requestProduct" type="text" />
            </div>
          </b-form-group>
        </form>
        <div class="d-flex flex-column justify-content-center align-items-center mt-5" v-if="providerId">
          <button class="inquiry-btn" @click="inquiry" :disabled="disabled">
            استعلام خرید
          </button>

          <p v-if="returnedLabelStatus" class="mt-3">
            نتیجه استعلام :
            <span class="font-weight-bold mr-1">{{ returnedLabelStatus }}.</span>
            <span v-if="returnedStatus == 'WAITING_FOR_CONFIRMATION'" class="d-flex align-items-center mt-2">
              در این وضعیت میتونید سفارش رو <button class="btn btn-danger btn-sm mx-2" @click="cancel">کنسل</button> کنید.
            </span>
            <span v-else-if="returnedStatus == 'PAID'" class="d-flex align-items-center mt-2">
              در این وضعیت میتونید سفارش رو <button class="btn btn-secondary btn-sm mx-2" @click="reverse">ریورس</button> کنید.
            </span>
          </p>
          
          <button class="btn btn-info mt-5" v-if="isBuy" @click="verify" :disabled="disabled">
            تایید خرید
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";

export default {
  name: "SendData",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BButton,
    Back,
  },
  data() {
    return {
      disabled: false,
      disabledBarcode: false,
      digipyBarcode: "",
      orderId: this.$route.params.id,
      digipayCashierAmount: this.$route.query.digipay_amount,
      adminId: this.$route.query.admin_id,
      storeId: this.$route.query.store_id,
      providerId: null,
      returnedStatus: "",
      returnedLabelStatus: "",
      isBuy: false,
      statuses: {
        WAITING_FOR_CONFIRMATION: "خرید در انتظار تایید مشتری است",
        PAID: "خرید انجام شده اما نهایی نشده است",
        CANCELED: "خرید انصراف داده شده است",
        COMPLETED: "خرید نهایی شده است",
        FAILED: "خرید ناموفق است",
        REVERSED: "خرید ریورس شده است",
        PROGRESS_IN_REVERSE: "ریورس در حال انجام است",
        REJECTED: "خرید رد شده است",
        PROCESSING: "خرید در حال پردازش است",
        EXPIRED: "خرید در زمان لازم توسط کاربر تایید نشده است",
      }
    };
  },
  methods: {
    async requestProduct() {
      try {
        this.disabledBarcode = true;
        const response = await this.$axios.post("admin/digify-cashier-payment",
          {
            barcode: this.digipyBarcode,
            terminalId: this.adminId,
            amount: this.digipayCashierAmount,
            order_id: this.orderId,
            branch_code: this.storeId,
          }
        );
        this.providerId = response.data;

        this.$root.notify("درخواست پرداخت با موفقیت ارسال شد.", "success");
        this.digipyBarcode = "";
      } catch (e) {
        this.$root.notify(e);
        this.disabledBarcode = false;
      } finally {
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    async inquiry() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/digify-cashier-inquiry",
          {
            params: {
              provider_id: this.providerId,
            }
          }
        );
        this.returnedStatus = response.data.purchaseStatus;
        this.returnedLabelStatus = this.statuses[response.data.purchaseStatus];
        this.isBuy = true;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async reverse() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/digify-cashier-reverse",
          {
            provider_id: this.providerId,
          }
        );
        console.log(response,'digify-cashier-reverse');
        this.$root.notify("سفارش با موفقیت کنسل شد.", "success");

      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async cancel() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/digify-cashier-cancel",
          {
            provider_id: this.providerId,
          }
        );
        this.$root.notify("خرید کنسل شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async cancelOrder() {
      try {
        this.disabled = true;
        const response = await this.$axios.post(`admin/mini-orders/${this.id}/cancel`);
        console.log(response.data,'response');
        this.$root.notify("سفارش با موفقیت کنسل شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async verify() {
      try {
        this.disabled = true;
        const response = await this.$axios.post("admin/digify-cashier-verify",
          {
            provider_id: this.providerId,
          }
        );
        this.$root.notify("خرید نهایی شد.", "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
  created() {

  },
};
</script>
<style src="@@/core/pages/physicalShop/digipay/digipayStyle.css"></style>